import { FC, memo } from 'react';
import get from 'lodash/get';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { useRecordContext } from 'ra-core';

import sanitizeFieldRestProps from './sanitizeFieldRestProps';
import { PublicFieldProps, InjectedFieldProps } from './types';
import { useUserTimeFormat } from '@/utils/userTimeFormat';


export const DateField2: FC<DateField2Props> = memo<DateField2Props>(props => {
    const {
        className,
        emptyText,
        locales,
        options,
        showTime = false,
        source,
        ...rest
    } = props;
    const format = useUserTimeFormat()
    const record = useRecordContext(props);
    if (!record) {
        return null;
    }
    const value = source && get(record, source);
    if (value == null) {
        return emptyText ? (
            <Typography
                component="span"
                variant="body2"
                className={className}
                {...sanitizeFieldRestProps(rest)}
            >
                {emptyText}
            </Typography>
        ) : null;
    }

    const date = value instanceof Date ? value : new Date(value);
    const dateString = showTime
        ? format(date, 'Pp')
        : format(date, 'P')

    return (
        <Typography
            component="span"
            variant="body2"
            className={className}
            {...sanitizeFieldRestProps(rest)}
        >
            {dateString}
        </Typography>
    );
});


export type DateField2Props =
    PublicFieldProps &
    InjectedFieldProps &
    TypographyProps & {
    locales?: string | string[];
    options?: object;
    showTime?: boolean;
}

export default DateField2;
